import Product from './Product';
import ProductWizard from './ProductWizard';

export { ProductWizard };

export default Product;
